import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../models/data.types'
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-header-nonav',
  templateUrl: './app-header-nonav.component.html'
})
export class AppHeaderNoNavComponent {

  private allUsers : Promise<User[]>;

  constructor(
    private router: Router,
    private apiService: ApiService) { 

      this.allUsers = this.GetAllUsers();
    }

  
    LogoutClick(){

      localStorage.clear();
      this.router.navigate(['/login']);
    }

    GetAllUsers(){

      return   this.apiService.postAs<any>('data/doquery/CW_GetAllUsers',null).then(
        response => {
              return  response.Items;
      })

    }

    
}



// WEBPACK FOOTER //
// ./src/app/components/app-header-nonav/app-header-nonav.component.ts